<template>
  <div class="report-common">
    <CommonSearch v-model="searchData" @search="doSearch(1, true)" :loading="loading"
      :adzoneList="adzoneList" :platformList="platformList" :mediaList="mediaList" 
      @export="onExportClick" :showAdzone="showAdzone" :showMedia="showMedia"/>
     <div class="card card-chart">
      <div class="card-title" :class="{collapse: !chartExpand}">
        <div class="title">图表数据</div>
        <div class="icon"><i :class="chartIconClass" @click="chartExpand = !chartExpand"></i></div>
        <div style="clear: both"></div>
      </div>
      <div class="card-body" v-if="chartExpand">
        <ReportChart class="chart" id="chart" ref="chart" :xdata="xdata" :ydata="sortedYdata" :height="500"/>
      </div>
    </div>
    <div class="card card-table">
      <div class="card-title">
        <ReportSearchColumn class="col" v-model="dimensionProp" @saveDimension="changeDimension()"/>
        <el-button class="col colPopover" plain @click="onExportClick" :disabled="loading">导出</el-button>
      </div>
      <div class="card-body">
        <ReportTable class="list" id="list" :cols="tableCols" :table-props="tableProps" :list="tableList" :curPage="curPage" :total="total" 
        @updateCurPage="updateCurPage" @sortChange="onSortChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  import ReportChart from '@/components/report/ReportChart'
  import ReportTable from "@/components/report/ReportTable";
  import CommonSearch from "@/components/report/CommonSearch";
  import ReportSearchColumn from "@/components/report/ReportSearchColumn";

  import exportUtils from '@/components/util/export-utils.js'

  import {commonProps} from '@/components/report/table-props'

  import {sspApi} from '@/api';

  export default {
    components: {
      ReportTable, 
      ReportChart, 
      ReportSearchColumn, 
      CommonSearch
    },
    data: function () {
      return {
        searchData: {
            dateRange: [],
            platformIds: [],
            timeDimension: 1,
            dimensionIds: [],
            mediaIds: [],
            adzoneIds: [],
            sort: {
              field: "",
              order: "",
            }
        },
        dimensionProp: {
          timeDimension: 1,
          dimensionIds: []
        },
        adzoneList: [],
        platformList: [],
        mediaList: [],
        chartList: [],
        dataColumns: [
            {column: "请求数", label: "请求数", nameProp: "raw_request_cnt"},
            {column: "返回数", label: "返回数", nameProp: "delivered_request_cnt"},
            {column: "曝光数", label: "曝光数", nameProp: "charged_impression_cnt"},
            {column: "预计收入", label: "预计收入", nameProp: "cost"},
        ],
        dataColumnValue: {
          0: '请求数', 1: '返回数', 2: '曝光数', 3: '预计收入'
        },
        chartExpand: false,
        xdata: [],
        ydata: [],
        loading: false,
        curPage: 1,
        total: 0,
        tableList: [],
        chartLoading: undefined,
        listLoading: undefined
      }
    },
    computed: {
      routeName: function () {
        return this.$route.name;
      },
      tableProps: function () {
        let props = commonProps;
        let res = [];
        for (let cfg of props) {
          let computedCfg = { ...cfg };
          if (this.compare) {
            computedCfg.sortable = false;
          }
          res.push(computedCfg);
        }
        return res;
      },
      chartIconClass: function () {
        return this.chartExpand ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
      },
      sortedYdata: function () {
        let dataColumnValues = Object.values(this.dataColumnValue) || [];
        let ydata = this.ydata || [];
        let res = ydata.filter(t => dataColumnValues.indexOf(t.name) >= 0)
          .sort((a, b) => dataColumnValues.indexOf(a.name) - dataColumnValues.indexOf(b.name));
        return res.slice(0, 4)
      },
      tableCols: function () {
        let dimension = []
        let origin = ['raw_request_cnt', 'delivered_request_cnt', 'fill_rate', 'charged_impression_cnt', 'charged_click_cnt', 'click_rate', 'ecpm', 'cost']

        switch (this.searchData.timeDimension) {
          case 1:
            dimension.push('dt')
            break
          case 2:
            dimension.push('weekofyear')
            break
          case 3:
            dimension.push('month')
            break
        }

        if (this.searchData.dimensionIds) {
          this.searchData.dimensionIds.forEach((it) => {
          switch(it) {
            case 1:
              dimension.push("platform_name")
              break
            case 2:
              dimension.push("ad_zone_id")
              dimension.push("ad_zone_name")
              break
            case 3:
              dimension.push("ssp_media_id")
              dimension.push("ssp_media_name")
              break
          }
        })
        }
       return dimension.concat(origin)
      },
      showAdzone: function() {
        return "reportAdzone" === this.routeName
      },
      showMedia: function() {
        return "reportAccount" !== this.routeName
      },
      exportConfigs: function () {
        if (!this.tableCols || this.tableCols.length == 0) {
          return [];
        }
        let res = [];
        let tableProps = this.tableProps || [];
        for (let config of tableProps) {
          let colName = config.prop;
          let cfg = { ...config };
          if (this.tableCols.indexOf(colName) >= 0 || config.required) {
            res.push(cfg);
          }
        }
        return res;
      }

    },
    watch: {
      routeName: function() {
        //route change, reload
        this.init()
      },
    },
    mounted: function () {
      sspApi.getReportConfig().then((response) => {
        this.adzoneList = response.adzoneList
        this.platformList = response.platformList
        this.mediaList = response.mediaList
      }).catch(this.$rejectAjaxError())
      this.init()
    },
    methods: {
      init: function () {
        this.xdata = []
        this.ydata = []
        this.chartExpand = false
        this.tableList = []
        this.curPage = 1
        this.total = 0

        let dimensionIds
        switch (this.routeName) {
          case 'reportAccount':
            dimensionIds = []
            break;
          case 'reportMedia':
            dimensionIds = [3]
            break;
          case 'reportAdzone':
            dimensionIds = [2]
            break;
          default:
            dimensionIds = []
            break;
        }

        this.searchData = {
            dateRange: [],
            platformIds: [],
            timeDimension: 1,
            dimensionIds: dimensionIds,
            mediaIds: [],
            adzoneIds: [],
            sort: {
              field: "",
              order: "",
            }
        }
        this.dimensionProp = {
          timeDimension: 1,
          dimensionIds: dimensionIds
        }
    },
    onSortChange: function (prop, order) {
      this.searchData.sort.field = prop
      this.searchData.sort.order = order
      //trigger reQuery
      this.doSearch(1, false)
    },
    changeDimension: function () {
      this.searchData.dimensionIds = this.dimensionProp.dimensionIds.sort().reverse()
      this.searchData.timeDimension = this.dimensionProp.timeDimension
      this.searchData.sort.field = ""
      this.searchData.sort.order = ""
      
      //trigger reQuery
      this.doSearch(1, true)
    },
    updateCurPage: function(page) {
      this.tableList = []
      this.curPage = page
      this.doSearch(this.curPage, false)
    },
    onExportClick: function() {
      let data = this.searchData
      this.loading = true
      let params = {export: true}
        sspApi.getTableReport({
          params,
          data: data,
          // responseType:'blob'
          }).then(res => {
                    // const downloadA = document.createElement('a');
                    // const blob = new Blob([res], {type:  "text/csv"});
                    // downloadA.href = window.URL.createObjectURL(blob);
                    // downloadA.download = "export"
                    // downloadA.click();
                    // URL.revokeObjectURL(downloadA.href);
                    exportUtils.export(res.dataList, this.exportConfigs)

                })
                .catch(() => {
                    this.$notify.error({title: "导出失败"});
                })
                .finally(() => {
                  this.loading = false
                })
    },
      doSearch: function (page, updateChart) {
        let data = this.searchData
        this.tableList = []
        this.chartList = []
        data.pageNum = page ? page : this.curPage

        if (!data || !data.dateRange || data.dateRange.length < 2) {
          this.$notify.error({ title: '请选择起止时间', message: '' });
          return
        }

        this.loading = true
        this.initLoading("#list")
        sspApi.getTableReport({
          data: data
          }).then((response) => {
            this.tableList = response.dataList
            this.curPage = response.curPage
            this.total = response.total
        }).catch(this.$rejectAjaxError())
        .finally(() => {
          this.closeLoading("#list")
          this.loading = false
        });

        if (!updateChart) {
          return
        }

        this.initLoading("#chart")
        sspApi.getChartReport({
          data: data
          }).then((response) => {
            this.chartList = response.dataList
            this.ydata = this.getYdata(this.chartList)
            let xField 
            switch (this.searchData.timeDimension) {
              case 1:
                xField = 'dt'
              break
              case 2:
                xField = 'weekofyear'
              break
              case 3:
                xField = 'month'
              break
            }
            let xdata = []
            if (this.chartList) {
              this.chartList.forEach((it) => {
                xdata.push(it[xField])
              })
            }
            this.xdata = xdata
            this.chartExpand = true
        }).catch(this.$rejectAjaxError())
        .finally(() => {
          this.closeLoading("#chart")
          this.loading = false
        });
      },
      buildLoading: function (target) {
        return this.$loading({
          lock: true,
          target,
          fullscreen: true,
          text: '正在查询。若等待时间过长，请减少自定义列细分维度，尝试重新查询',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
      },
      initLoading: function (loadingTarget) {
        this.loading = true;
        if (loadingTarget === "#chart") {
          if (this.$refs.chart) {
            this.chartLoading = this.buildLoading(loadingTarget);
          }
        } else if (loadingTarget === "#list") {
          this.listLoading = this.buildLoading(loadingTarget);
        }
      },
      closeLoading: function (loadingTarget) {
        if (loadingTarget === "#chart") {
          if (this.chartLoading) {
            this.chartLoading.close()
          }
        } else if (loadingTarget === "#list") {
          if (this.listLoading) {
            this.listLoading.close()
          }
        }
      },
      getYdata: function (list) {
        let ydata = [];
        for (let obj of this.dataColumns) {
          let {column, nameProp} = obj;
          ydata.push({
            name: column, value: list.map(t => t[nameProp])
          });
        }
        return ydata;
      },
    }
}

</script>

<style scoped>
  .right {
    float: right
  }

  .card-title {
    font-size: 14px;
    color: #999999;
    background-color: #F5F5F5;
    padding: 12px;
    border: 1px solid #F5F5F5;
    border-bottom: none;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .card-chart {
    margin-top: 40px
  }

  .card-chart .card-title.collapse {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .card-body {
    font-size: 16px;
    padding: 10px 20px;
    border: 1px solid #F5F5F5;
    border-top: none;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .col {
    display: inline-block;
    margin-right: 10px;
  }

  .col2, .col3 {
    font-size: 14px;
  }

  .card-title .title {
    float: left;
  }

  .card-title .icon {
    float: right;
    cursor: pointer;
  }

  .chart {
    border: 1px solid #F5F5F5;
    padding: 10px 0;
  }

  .dataColumns {
    margin: 0 0 10px 0;
  }

  .dimension {
    margin-right: 10px;
  }

  .card-table {
    margin-top: 20px;
  }

  .card-table .card-title {
    line-height: 30px;
  }

  /* .export-btn {
    width: 70px;
    height: 29px;
    border-color: #dcdfe6;
    color: #999999 !important;
  } */
.colPopover {
  background-color: white;
  height: 30px;
}
.colPopover >>> span {
  color: #999999;
  font-size: 14px;
  margin-top: 1px;
}
  
</style>